import { render } from "./QuestionNestedDraggableItemComponent.vue?vue&type=template&id=645a80ad"
import script from "./QuestionNestedDraggableItemComponent.vue?vue&type=script&lang=js"
export * from "./QuestionNestedDraggableItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__